import { EventBusService } from './../../services/event-bus-service';
import { AuthenticationService } from './../../services/authentication.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Component, ComponentRef, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { first } from 'rxjs/operators';
import { WebStorageService } from '../../services';
import constants from '../../utility/constants';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading: boolean = false;
  hidelp: boolean = true;
  error: string = '';
  public Formdata: any = {};
  rememberme: string;
  rememberme1: any;
  rememberId: any = 1;
  session: boolean = true;
  ref: ComponentRef<LoginComponent>;
  email: string = '';
  password: string = '';
  private subscriptions: Array<Subscription> = [];

  private readonly loginTypes = constants.common.loginType;

  constructor(
    public modalRef: BsModalRef,
    public formBuilder: FormBuilder,
    public authenticationService: AuthenticationService,
    public ebs: EventBusService,
    public modelService: BsModalService,
    private storage: WebStorageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required),
      rememberme: new FormControl(
        this.storage.getRememberMe() || false,
        Validators.required
      ),
    });
    this.email = '';
    this.password = '';
  }
  ngAfterOnInit() {
    this.session = !this.session;
  }
  hideAndReset() {
    this.loginForm.reset();
    this.modalRef.hide();
  }
  login() {
    this.loading = true;
    let loginType = this.loginTypes.public;
    const login = this.authenticationService
      .login(
        this.loginForm.get('email').value,
        this.loginForm.get('password').value,
        loginType
      )
      .pipe(first())
      .subscribe(
        (response) => {
          let rememberMe = this.loginForm.get('rememberme').value;
          this.storage.setRememberMe(rememberMe);
          this.storage.setBuyer(response, true);
          this.ebs.notification.emit('user-dashboard');
          if (!response.user.isProfileComplete) {
            this.ebs.setName(
              response.user.firstName + ' ' + response.user.lastName
            );
            this.router.navigateByUrl('profile/edit-profile');
          } else {
            location.reload();
          }
          try {
            this.ref.destroy();
          } catch (e) {}
          this.ebs.setName(
            response.user.firstName + ' ' + response.user.lastName
          );
          this.loading = false;
          this.hideAndReset();
          this.modelService.hide();
        },
        (error) => {
          this.loading = false;
          this.error = error;
        }
      );
      this.subscriptions.push(login)
  }

  openModalFile(modalName: String) {
    this.ebs.notification.emit(modalName);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
